export const CONSIGNMENT_STATUS_OPTIONS = [
  { code: 'ALL', label: 'All' },
  { code: 'UNCONTROL', label: 'Uncontrolled' },
  { code: 'CONTROL', label: 'Controlled' },
];

export const INVENTORY_STATUS_OPTIONS = [
  { code: 'ALL', label: 'All' },
  { code: 'AVAILABLE', label: 'Available' },
  { code: 'INTRANSIT', label: 'In Transit' },
];
